import { apiPlugin, storyblokInit } from '@storyblok/js';
import { STORY_BLOK_ACCESS_TOKEN } from 'root/src/envVariables';

export const { storyblokApi } = storyblokInit({
  accessToken: STORY_BLOK_ACCESS_TOKEN,
  use: [apiPlugin],
});
